import { useBehaviorSubject } from '@base/utils/helpers';
import { container } from 'tsyringe';
import './index.scss';
import '@ui-kit/styles/index.scss';
import { ReactComponent as BackgammonIcon } from '@ui-kit/images/backgammonIcon.svg';
import { IdleTimer } from '@base/features/player/components/idleTimer';
import { Routes } from './routes';
import Header from '@base/ui/components/header';
import { ILanguageService } from '@base/features/i18n/model/interfaces';
import Modals from '../modal/components/modals';
import PaymentsProvider from '../tickets/components/paymentsProvider';
import useSession from '@base/utils/hooks/useSession';
import useTableSwitcher from '../routing/components/useTableSwitcher';

const AppComponent = () => {
  const languageService: ILanguageService = container.resolve('languageService');
  useBehaviorSubject(languageService.currentLanguage);
  useTableSwitcher();
  const currentUser = useSession();

  return (
    <PaymentsProvider>
      <Header currentUser={currentUser?.usr} icon={<BackgammonIcon />} />
      <Routes currentUser={currentUser?.usr} />
      <Modals />
      <IdleTimer />
    </PaymentsProvider>
  );
};

export default AppComponent;
